import {
	SET_LEADERBOARD,
	SET_EVENT_LEADERBOARDS,
	DELETE_LEADERBOARD,
} from '../actions/actionTypes';
import { arrToObj } from '../util';

export const parseLeaderboard = leaderboard => {
	const teams = leaderboard.teams.map(teamObj => teamObj.id);
	return { ...leaderboard, teams };
};

const leaderboardsReducer = (state = {}, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, leaderboards, leaderboard, leaderboardID } = action;

	switch (type) {
		case SET_LEADERBOARD:
			stateDup[leaderboard.id] = parseLeaderboard(leaderboard);
			return stateDup;
		case DELETE_LEADERBOARD:
			delete stateDup[leaderboardID];
			return stateDup;
		case SET_EVENT_LEADERBOARDS:
			return arrToObj(leaderboards, parseLeaderboard);
		default:
			return stateDup;
	}
};

export default leaderboardsReducer;
